//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import React from 'react';
import styled, { css } from 'styled-components';

import { mapObject } from '@utils/mapObject';

export enum BoundingBoxVisibilityState {
  HIDDEN = 'Hidden',
  VISIBLE = 'Visible',
  HIGHLIGHTED = 'Highlighted',
}

export interface IBoundingBoxSpatialData {
  height: number;
  width: number;
  x: number;
  y: number;
}

interface IOwnProps {
  boxId: string;
  coordinates: IBoundingBoxSpatialData;
  visibilityState: BoundingBoxVisibilityState;
  handleSuggestionBoxClicked: (boxId: string, e: React.MouseEvent) => void;
}
type Props = IOwnProps;

const getPercentStrFromDouble = (value: number) => `${value * 100}%`;

const ProductSuggestionBoundingBox: React.FunctionComponent<Props> = ({
  boxId,
  coordinates,
  visibilityState,
  handleSuggestionBoxClicked,
}) => {
  const percentCoordinates = mapObject(coordinates, getPercentStrFromDouble);

  return (
    <BoundingBox
      data-testid='bounding-box'
      onClick={(e) => handleSuggestionBoxClicked(boxId, e)}
      height={percentCoordinates.height}
      width={percentCoordinates.width}
      x={percentCoordinates.x}
      y={percentCoordinates.y}
      visibilityState={visibilityState}
    />
  );
};

interface IBoundingBoxProps {
  height: string;
  width: string;
  x: string;
  y: string;
  visibilityState: BoundingBoxVisibilityState;
}

const BoundingBox = styled.div<IBoundingBoxProps>`
  ${({ height, width, x, y, visibilityState }) => {
    return css`
      border: 2px solid;
      border-color: rgba(255, 255, 255);
      box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
      position: absolute;
      opacity: ${() => {
        switch (visibilityState) {
          case 'Hidden':
            return 0;
          case 'Visible':
            return 0.6;
          case 'Highlighted':
            return 1;
        }
      }};
      z-index: 2;
      height: ${height};
      width: ${width};
      left: ${x};
      top: ${y};

      &:hover {
        cursor: crosshair;
        opacity: 1;
      }
    `;
  }}
`;

export default ProductSuggestionBoundingBox;
